import { render, staticRenderFns } from "./SideBySide.vue?vue&type=template&id=63a020dc"
import script from "./SideBySide.vue?vue&type=script&lang=js"
export * from "./SideBySide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports